var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "previewModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg",
        },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [_vm._v("預覽信件")]),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: {
                      click: function ($event) {
                        return _vm.$store.commit("OpenPreviewMailModal", false)
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]),
              _c("perfect-scrollbar", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "preview-body row" }, [
                  _c("div", { staticClass: "col-1" }, [_c("Logo")], 1),
                  _c(
                    "div",
                    {
                      staticClass: "col-10",
                      staticStyle: { "padding-left": "5px" },
                    },
                    [
                      _vm._v(" 收件者："),
                      _vm._l(
                        _vm.previewMail.Recipients,
                        function (recipient, index) {
                          return _c(
                            "span",
                            { key: recipient[index] },
                            [
                              _c("el-tag", { attrs: { size: "small" } }, [
                                _vm._v(
                                  _vm._s(
                                    recipient.Name +
                                      "(" +
                                      recipient.Address +
                                      ")"
                                  )
                                ),
                              ]),
                              _vm._v("; "),
                            ],
                            1
                          )
                        }
                      ),
                      _c("br"),
                      _vm.type !== "job"
                        ? [
                            _vm._v(" 副本："),
                            _vm._l(_vm.previewMail.CCs, function (cc, index) {
                              return _c(
                                "span",
                                { key: cc[index] },
                                [
                                  _c(
                                    "el-tag",
                                    { attrs: { size: "small", type: "info" } },
                                    [
                                      _vm._v(
                                        _vm._s(cc.Name + "(" + cc.Address + ")")
                                      ),
                                    ]
                                  ),
                                  _vm._v("; "),
                                ],
                                1
                              )
                            }),
                            _c("br"),
                          ]
                        : _vm._e(),
                      _c("span", [
                        _vm._v("主旨：" + _vm._s(_vm.previewMail.Subject)),
                      ]),
                    ],
                    2
                  ),
                ]),
                _c("div", {
                  staticClass: "mt-1",
                  domProps: { innerHTML: _vm._s(_vm.previewMail.Body) },
                }),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }